export const LANDING_SESSION_KEYS = {
  exitPopupSeen: 'fixdauto-exit-popup-seen',
  landingConverted: 'fixdauto-landing-converted',
} as const

export function markLandingConverted(): void {
  try {
    sessionStorage.setItem(LANDING_SESSION_KEYS.landingConverted, '1')
  } catch {
    // ignore
  }
}

export function hasLandingConverted(): boolean {
  try {
    return sessionStorage.getItem(LANDING_SESSION_KEYS.landingConverted) === '1'
  } catch {
    return false
  }
}

export function hasExitPopupBeenSeen(): boolean {
  try {
    return sessionStorage.getItem(LANDING_SESSION_KEYS.exitPopupSeen) === '1'
  } catch {
    return false
  }
}

export function markExitPopupSeen(): void {
  try {
    sessionStorage.setItem(LANDING_SESSION_KEYS.exitPopupSeen, '1')
  } catch {
    // ignore
  }
}
